module.exports = __webpack_public_path__ + "static/media/bg-superiority-4.d14c1741.png";